export default "__VITE_ASSET__fa30e023__"